/* Badstugutta Tracking — Hull 2 i tracking-plan
 *
 * Fanger gclid + UTM-parametere fra URL ved page load og lagrer dem i first-party
 * cookies (90 dager). Deretter eksponerer window.BG.getTracking() som alle skjemaer
 * leser før submit, så vi kan koble en lead tilbake til hvilken annonse de kom fra.
 *
 * Brukes av: Konfigurator inquiry-form, Quiz contact form, Shopify popup-inquiry,
 * Shopify kontaktskjema, og alle andre lead-skjemaer.
 *
 * Sammenkoblet med:
 * - Stoke /api/leads/ingest (gclid+utm i payload)
 * - Close custom fields (cf_Ewr5O3M6MlD7... osv.)
 * - Google Ads Offline Conversions Import (Hull 3 — månedlig)
 */
(function () {
  'use strict';

  var COOKIE_PREFIX = 'bg_';
  var COOKIE_MAX_AGE = 90 * 24 * 60 * 60; // 90 dager
  // Bruk subdomain-bred cookie så konfigurator.badstugutta.no også ser den
  var COOKIE_DOMAIN = '.badstugutta.no';
  // Lokal utvikling: .badstugutta.no virker ikke — fall tilbake til ingen domain
  var IS_LOCAL = location.hostname === 'localhost' || location.hostname === '127.0.0.1';

  // Standardparametere vi fanger fra URL
  var TRACKED_PARAMS = [
    'gclid',
    'fbclid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term'
  ];

  function setCookie(name, value) {
    if (!value) return;
    var parts = [
      COOKIE_PREFIX + name + '=' + encodeURIComponent(value),
      'max-age=' + COOKIE_MAX_AGE,
      'path=/',
      'SameSite=Lax'
    ];
    if (!IS_LOCAL) {
      parts.push('domain=' + COOKIE_DOMAIN);
      // Bare sett Secure på HTTPS — vi er alltid HTTPS i prod
      parts.push('Secure');
    }
    document.cookie = parts.join('; ');
  }

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(^|;\\s*)' + COOKIE_PREFIX + name + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[2]) : null;
  }

  function captureFromUrl() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }

    // Last click attribution — overskriv cookie hvis ny gclid i URL.
    // Hvis bare UTM-param uten gclid, behold eksisterende gclid (siste klikk-attribusjon
    // for paid søk er strengere enn for UTM).
    var hasNewGclid = !!params.get('gclid');
    var hasAnyTrackingParam = TRACKED_PARAMS.some(function (k) {
      return !!params.get(k);
    });

    if (!hasAnyTrackingParam) return;

    TRACKED_PARAMS.forEach(function (key) {
      var value = params.get(key);
      if (value) {
        setCookie(key, value);
      } else if (key === 'gclid' && hasNewGclid) {
        // gclid eksisterte men was empty string — skip
      }
    });

    // Lagre referrer + landing URL ved første touchpoint hvor vi får nye param
    if (hasNewGclid || hasAnyTrackingParam) {
      var ref = document.referrer || '';
      if (ref) setCookie('referrer', ref);
      setCookie('landing_url', window.location.href.split('#')[0]);
      setCookie('landing_at', new Date().toISOString());
    }
  }

  function getTracking() {
    var data = {};
    TRACKED_PARAMS.forEach(function (k) {
      var v = getCookie(k);
      if (v) data[k] = v;
    });
    var ref = getCookie('referrer');
    if (ref) data.referrer_url = ref;
    var landing = getCookie('landing_url');
    if (landing) data.landing_url = landing;
    var landingAt = getCookie('landing_at');
    if (landingAt) data.landing_at = landingAt;
    return data;
  }

  /**
   * Injiserer hidden input-felter med tracking-data i et form-element.
   * Kall denne på et form for å automatisk legge til gclid/utm-felter
   * som vil bli sendt med submit.
   */
  function injectFormFields(formEl) {
    if (!formEl || formEl.tagName !== 'FORM') return;
    var data = getTracking();
    Object.keys(data).forEach(function (key) {
      // Skip hvis feltet allerede finnes (unngå duplikater)
      if (formEl.querySelector('input[name="' + key + '"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = data[key];
      formEl.appendChild(input);
    });
  }

  /**
   * Auto-injiser tracking-felter i alle skjemaer med data-bg-track attributtet.
   * Brukes som: <form data-bg-track>...</form>
   */
  function autoInject() {
    var forms = document.querySelectorAll('form[data-bg-track]');
    forms.forEach(injectFormFields);
  }

  /**
   * Decorer en Calendly-lenke med tracking-params slik at GCLID + UTM havner i
   * Calendly-webhook payload.tracking.* (som videresendes til Stoke + Google Ads
   * offline conversion). GCLID smugles inn i utm_content (Calendly har ikke
   * native GCLID-felt). Max 255 tegn per UTM-verdi.
   *
   * Trygt å kalle flere ganger — bruker data-bg-decorated for å unngå duplikering.
   *
   * Fra booking-byttet (sep 2026): lenker til book.badstugutta.no går til
   * decorateBookLink() over. Calendly-grenen under er uendret og beholdes for
   * lenker som måtte henge igjen i overgangen.
   */
  var BOOK_HOST = 'book.badstugutta.no';
  var BOOKING_SELECTOR = 'a[href*="calendly.com"], a[href*="' + BOOK_HOST + '"]';

  /**
   * Egen bookingside (book.badstugutta.no, erstatter Calendly). Den tar imot
   * gclid og fbclid som EKTE parametere, saa ingenting smugles i utm_content.
   * Lenkas egne UTM-er overstyres aldri; vi fyller bare inn det som mangler.
   * (Bookingsiden leser ogsaa bg_-cookiene selv. Dette er belte og bukseseler
   * for nettlesere som blokkerer cookies paa tvers av underdomener.)
   */
  function decorateBookLink(link, rawHref) {
    var tracking = getTracking();
    var url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (e) {
      return;
    }
    if (url.hostname !== BOOK_HOST) return;

    var keys = ['gclid', 'fbclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var changed = false;
    keys.forEach(function (k) {
      if (tracking[k] && !url.searchParams.get(k)) {
        url.searchParams.set(k, tracking[k]);
        changed = true;
      }
    });
    // Samme standardverdier som Calendly-grenen: gclid uten UTM = Google Ads-klikk
    if (tracking.gclid && !url.searchParams.get('utm_source')) {
      url.searchParams.set('utm_source', 'googleads');
      changed = true;
    }
    if (tracking.gclid && !url.searchParams.get('utm_medium')) {
      url.searchParams.set('utm_medium', 'cpc');
      changed = true;
    }

    if (changed) link.setAttribute('href', url.toString());
    link.dataset.bgDecorated = '1';
  }

  function decorateCalendlyLink(link) {
    if (!link || link.dataset.bgDecorated === '1') return;

    var bookHref = link.getAttribute('href');
    if (bookHref && bookHref.indexOf(BOOK_HOST) !== -1) {
      decorateBookLink(link, bookHref);
      return;
    }

    var tracking = getTracking();
    var hasAnyData = tracking.gclid || tracking.utm_source ||
      tracking.utm_campaign || tracking.utm_medium;
    if (!hasAnyData) return;

    var rawHref = link.getAttribute('href');
    if (!rawHref || rawHref.indexOf('calendly.com') === -1) return;

    var url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (e) {
      return;
    }

    // Default verdier hvis GCLID finnes men UTM mangler
    var source = tracking.utm_source || (tracking.gclid ? 'googleads' : null);
    var medium = tracking.utm_medium || (tracking.gclid ? 'cpc' : null);

    if (source) url.searchParams.set('utm_source', source);
    if (medium) url.searchParams.set('utm_medium', medium);
    if (tracking.utm_campaign) url.searchParams.set('utm_campaign', tracking.utm_campaign);
    if (tracking.utm_term) url.searchParams.set('utm_term', tracking.utm_term);

    // GCLID inn i utm_content (Calendly har ikke native GCLID-felt).
    // Hvis gclid finnes, overstyr utm_content. Ellers behold utm_content.
    if (tracking.gclid) {
      url.searchParams.set('utm_content', tracking.gclid);
    } else if (tracking.utm_content) {
      url.searchParams.set('utm_content', tracking.utm_content);
    }

    link.setAttribute('href', url.toString());
    link.dataset.bgDecorated = '1';
  }

  function decorateAllCalendlyLinks() {
    var links = document.querySelectorAll(BOOKING_SELECTOR);
    links.forEach(decorateCalendlyLink);
  }

  // Event delegation: dekor lenker rett før klikk (dekker dynamisk innhold)
  function attachCalendlyClickListener() {
    document.addEventListener('click', function (e) {
      var link = e.target && e.target.closest && e.target.closest(BOOKING_SELECTOR);
      if (link) decorateCalendlyLink(link);
    }, true);
  }

  // Capture på page load
  captureFromUrl();

  // Eksponer API for andre skripter (Konfigurator, Quiz, etc.)
  window.BG = window.BG || {};
  window.BG.getTracking = getTracking;
  window.BG.injectFormFields = injectFormFields;
  window.BG.decorateCalendlyLink = decorateCalendlyLink;
  window.BG.decorateAllCalendlyLinks = decorateAllCalendlyLinks;
  window.BG.decorateBookLink = decorateCalendlyLink; // samme inngang, velger gren selv

  // Auto-inject i forms som har data-bg-track attributtet
  // + auto-decorer Calendly-lenker (statisk + dynamisk via click-handler)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      autoInject();
      decorateAllCalendlyLinks();
      attachCalendlyClickListener();
    });
  } else {
    autoInject();
    decorateAllCalendlyLinks();
    attachCalendlyClickListener();
  }
})();
